import { useState } from 'react';
import _ from 'lodash';
import { systemAPI } from '../../../apis';

export default function useGetRemarksListAPI() {
  const [remarkList, setRemarkList] = useState([]);
  const defaultParams = {
    keyword: '',
    status: 1,
  };
  const getRemarksListAPI = async (params) => {
    try {
      const { result } = await systemAPI.getEquipmentRemarkList({ ...defaultParams, ...params });
      const remarkList = _.map(result, (item) => ({ content: item }));
      setRemarkList(remarkList);
    } catch (error) {}
  };

  return {
    remarkList,
    getRemarksListAPI,
  };
}
